export const PROVIDER_DETAILS_SCHEMA = [
  {
    elementConfig: {
      label: "Full Name",
      placeholder: "Full Name",
      type: "text",
    },
    elementType: "input",
    name: "name",
  },
  {
    elementConfig: {
      label: "Email",
      placeholder: "Email",
      type: "email",
    },
    elementType: "input",
    name: "email",
  },
  {
    elementConfig: {
      label: "CP Credential",
      placeholder: "CP Credential",
      type: "email",
    },
    elementType: "input",
    name: "cp_credentials",
  },
  {
    elementConfig: {
      label: "NPI Number",
      placeholder: "NPI Number",
      type: "text",
    },
    elementType: "input",
    name: "npi_number",
  },
  {
    elementConfig: {
      label: "Mobile",
      placeholder: "Mobile",
      type: "text",
    },
    elementType: "input",
    name: "mobile",
  },
  {
    elementConfig: {
      label: "Provider Type",
      placeholder: "Provider Type",
      type: "text",
    },
    elementType: "input",
    name: "provider_type",
  },
  {
    elementConfig: {
      label: "Intake Coordinator For Practice(s)",
      options: [],
      placeholder: "Intake Coordinator For Practice(s)",
    },
    elementType: "react-select",
    name: "intake_practice_ids",
  },
];

const PROVIDER_PRACTICE_DETAILS_SCHEMA = [
  {
    elementConfig: {
      label: "Default Practice",
      options: [],
    },
    elementType: "react-select",
    name: "default_practice_id",
  },
];
